// Import Kandinsky
import Logo from "./js/site/elements/ThreeJsLogo";
import { Loader } from "./js/kandinsky/components/Loader";

// Include local stylesheet
import "./App.scss";


/*
/assets/img/textures/metal-clean/roughness.jpeg
/assets/img/textures/metal-clean/normal.jpeg
/assets/img/cubemap@1024/px.jpg
/assets/img/cubemap@1024/nx.jpg
/assets/img/cubemap@1024/py.jpg
/assets/img/cubemap@1024/ny.jpg
/assets/img/cubemap@1024/pz.jpg
/assets/img/cubemap@1024/nz.jpg
*/

export default function App() {


  return (
     <Loader manifest={[{
      src : `/assets/img/textures/metal-clean/roughness.jpeg`
     },{
      src : `/assets/img/textures/metal-clean/normal.jpeg`
     },
     {
      src : `/assets/img/cubemap@1024/px.jpg`
     },
     {
      src : `/assets/img/cubemap@1024/nx.jpg`
     },
     {
      src : `/assets/img/cubemap@1024/py.jpg`
     },
     {
      src : `/assets/img/cubemap@1024/ny.jpg`
     },
     {
      src : `/assets/img/cubemap@1024/pz.jpg`
     },
     {
      src : `/assets/img/cubemap@1024/nz.jpg`
     }]} wait={0} progress={() => null}>
      {() => (
        <Logo />
      )}
    </Loader>
  );
}
